module.exports = __webpack_public_path__ + "img/2-PORTADA.f319120c.jpg";